export type UserRole =
  | 'PLATFORM_ADMIN'
  | 'CLIENT_ADMIN'
  | 'COMPANY_ADMIN'
  | 'OPERATOR'
  | 'ANALYST'
  | 'CUSTOMER_VIEWER'
  | 'CUSTOMER_MANAGER';

export const USER_ROLES: Record<UserRole, string> = {
  PLATFORM_ADMIN: 'Administrador da Plataforma',
  CLIENT_ADMIN: 'Administrador do Cliente',
  COMPANY_ADMIN: 'Administrador da Empresa',
  OPERATOR: 'Operador',
  ANALYST: 'Analista',
  CUSTOMER_VIEWER: 'Visualizador Externo',
  CUSTOMER_MANAGER: 'Gestor Externo',
};

export const ROLE_HIERARCHY: Record<UserRole, number> = {
  PLATFORM_ADMIN: 100,
  CLIENT_ADMIN: 80,
  COMPANY_ADMIN: 60,
  ANALYST: 40,
  OPERATOR: 20,
  CUSTOMER_MANAGER: 15,
  CUSTOMER_VIEWER: 10,
};

export interface AuthUser {
  uid: string;
  email: string | null;
  displayName: string | null;
  photoURL: string | null;
  emailVerified: boolean;
}
